import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../common/breadcrumb";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ConnectOnboard from "./components/ConnectOnboard";
import EmoneyOnboard from "./components/EmoneyOnboard";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const AddAccount = () => {
  const { accountType, accountId, id } = useParams();
  const [value, setValue] = useState(accountType || "e-money");
  const { user } = useSelector((state) => state.auth);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleType = (e) => {
    setValue(e.target.value);
  };

  return (
    <div>
      <Helmet>
        <title>eksplode! | Payment Integration</title>
      </Helmet>
      <Breadcrumb title={"Add Account"} />

      <section className="about-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="box-head">
                <div className="d-flex justify-content-between">
                  <h2 className="text-dark">
                    {accountId ? "Complete The On-boarding" : "Add Account"}
                  </h2>
                  {accountType && (
                    <Link
                      to={`/account-list?accountType=${accountType}`}
                      className="btn btn-solid mt-2"
                    >
                      My Accounts
                    </Link>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                {!id && (
                  <>
                    <div className="col-12 mb-3">
                      <label htmlFor="fname">First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        value={user?.user?.first_name}
                        disabled
                      />
                    </div>

                    <div className="col-12 mb-3">
                      <label htmlFor="fname">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Last Name"
                        value={user?.user?.last_name}
                        disabled
                      />
                    </div>

                    <div className="col-12 mb-3">
                      <label htmlFor="fname">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        value={user?.user?.email}
                        disabled
                      />
                    </div>

                    <div className="col-12 mb-3">
                      <label htmlFor="fname">Selected Account Type</label>
                      {accountType ? (
                        <div className="text-capitalize">{accountType}</div>
                      ) : (
                        <div className="d-flex align-items-center">
                          <div className="d-flex justify-content-start mr-2">
                            <input
                              type="radio"
                              className="form-control w-auto mr-2"
                              id="e-money"
                              name="e-money"
                              value="e-money"
                              checked={value === "e-money"}
                              onChange={handleType}
                            />
                            <label htmlFor="e-money" className="mb-0">
                              E-Money
                            </label>
                          </div>
                          <div className="d-flex justify-content-start">
                            <input
                              type="radio"
                              className="form-control w-auto mr-2"
                              id="bank-account"
                              name="bank-account"
                              value="bank-account"
                              checked={value === "bank-account"}
                              onChange={handleType}
                            />
                            <label htmlFor="bank-account" className="mb-0">
                              Bank-Account
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="col-12 mb-3">
                  {value === "e-money" ? (
                    <EmoneyOnboard
                      type={value}
                      // accountId={accountId}
                    />
                  ) : (
                    <ConnectOnboard
                      type={value}
                      // accountId={accountId}
                      // id={id}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* {!accountType && (
              <div className="col-12 mb-4">
                <Tabs value={value} onChange={handleChange}>
                  <Tab value="e-money" label="E-money Account" />
                  <Tab value="bank-account" label="Bank Account" />
                </Tabs>
              </div>
            )}

            <div className="col-12">
              {value === "e-money" ? (
                <EmoneyOnboard type={value} accountId={accountId} />
              ) : (
                <ConnectOnboard type={value} accountId={accountId} />
              )}
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddAccount;
